import qs from "qs";

export const serialize = (data: any, useSearch = false) => {
    const params = qs.stringify(data, { arrayFormat: "brackets" });

    return !params || !useSearch ? params : `?${params}`;
};
